module.exports = __webpack_public_path__ + "assets/7566c9776540720d35e2a10ed2921c5b.json";